import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useAuth } from "../contexts/AuthContext";
import AuthDialog from "./AuthDialog";
import { isAdmin as checkIsAdmin } from "../Utils/functions";
import { useNavigate } from "react-router-dom";

const AuthButton = () => {
  const [authMenuAnchor, setAuthMenuAnchor] = useState(null);
  const [authDialogOpen, setAuthDialogOpen] = useState(false);
  const [authDialogTab, setAuthDialogTab] = useState(0);
  const { user, logout, isAuthenticated } = useAuth();
  const isAdmin = checkIsAdmin(user);
  const navigate = useNavigate();

  const handleAuthMenuOpen = (event) => {
    setAuthMenuAnchor(event.currentTarget);
  };

  const handleAuthMenuClose = () => {
    setAuthMenuAnchor(null);
  };

  const handleLoginClick = () => {
    setAuthDialogTab(0);
    setAuthDialogOpen(true);
    handleAuthMenuClose();
  };

  const handleRegisterClick = () => {
    setAuthDialogTab(1);
    setAuthDialogOpen(true);
    handleAuthMenuClose();
  };

  const handleLogout = () => {
    logout();
    handleAuthMenuClose();
  };

  const handleAdminClick = () => {
    navigate("/admin");
    handleAuthMenuClose();
  };

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          right: 16,
          top: "50%",
          transform: "translateY(-50%)",
        }}
      >
        {isAuthenticated ? (
          <IconButton
            onClick={handleAuthMenuOpen}
            sx={{
              color: "#9aa2ae",
              "&:hover": {
                opacity: 0.7,
                backgroundColor: "transparent",
              },
            }}
          >
            {/* <Typography variant="body2">
              {user?.displayName || user?.username || user?.email}
            </Typography> */}
            <AccountCircleIcon />
          </IconButton>
        ) : (
          <IconButton
            onClick={handleAuthMenuOpen}
            sx={{
              color: "#9aa2ae",
              "&:hover": {
                opacity: 0.7,
                backgroundColor: "transparent",
              },
            }}
          >
            <AccountCircleIcon />
          </IconButton>
        )}

        <Menu
          anchorEl={authMenuAnchor}
          open={Boolean(authMenuAnchor)}
          onClose={handleAuthMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          sx={{
            "& .MuiPaper-root": {
              backgroundColor: "#4b4b4b",
              borderRadius: 0,
            },
          }}
        >
          {isAuthenticated ? (
            <>
              <MenuItem
                disabled
                sx={{
                  color: "#9aa2ae",
                  opacity: 0.8,
                  "&.Mui-disabled": {
                    opacity: 0.5,
                  },
                }}
              >
                <Typography variant="body2">
                  {user?.displayName || user?.email}
                </Typography>
              </MenuItem>
              {isAdmin && (
                <MenuItem
                  onClick={handleRegisterClick}
                  sx={{
                    color: "#9aa2ae",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
                  }}
                >
                  Register
                </MenuItem>
              )}
              {isAdmin && (
                <MenuItem
                  onClick={handleAdminClick}
                  sx={{
                    color: "#9aa2ae",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.1)",
                    },
                  }}
                >
                  <AdminPanelSettingsIcon sx={{ mr: 1, fontSize: 20 }} />
                  Admin
                </MenuItem>
              )}
              <MenuItem
                onClick={handleLogout}
                sx={{
                  color: "#9aa2ae",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                Logout
              </MenuItem>
            </>
          ) : (
            <>
              <MenuItem
                onClick={handleLoginClick}
                sx={{
                  color: "#9aa2ae",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                  },
                }}
              >
                Login
              </MenuItem>
            </>
          )}
        </Menu>
      </Box>

      <AuthDialog
        open={authDialogOpen}
        onClose={() => setAuthDialogOpen(false)}
        initialTab={authDialogTab}
      />
    </>
  );
};

export default AuthButton;
